export const UPDATE_STATEMENT_TEMPLATE_PLACEHOLDER_SUCCESS = 'UPDATE_STATEMENT_TEMPLATE_PLACEHOLDER_SUCCESS';

export const updateStatementTemplatePlaceholderSuccess = ({ statementTemplatePlaceholder }) => ({
    type: UPDATE_STATEMENT_TEMPLATE_PLACEHOLDER_SUCCESS,
    payload: {
        statementTemplate,
    },
});
